import { AfterViewInit, Directive, ElementRef, HostListener, inject, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { fromEvent } from 'rxjs';

import { markEventAsHandled } from '@blaze-runtime/engine-util';

@UntilDestroy()
@Directive({
  selector: '[blazeElementSelectionHelper]',
  standalone: false,
})
export class ElementSelectionHelperDirective implements AfterViewInit {
  private element = inject(ElementRef);

  @Input() isInEditor? = false;
  inputRef!: HTMLElement;

  ngAfterViewInit(): void {
    this.inputRef = this.element.nativeElement.querySelector('.allow-selection');

    if (this.inputRef) {
      ['mousedown', 'click'].forEach((eventName) => {
        fromEvent(this.inputRef, eventName)
          .pipe(untilDestroyed(this))
          .subscribe((event) => this.makeElementSelected(event));
      });
    }
  }

  @HostListener('mousedown', ['$event'])
  elementMouseDown(event: Event): void {
    if (!this.isInEditor) {
      markEventAsHandled(event);
    }
  }

  makeElementSelected(event: Event): void {
    markEventAsHandled(event);
  }
}
